import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import i18n, { syncDocumentLanguage } from "./i18n";

syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
